import * as React from "react";
import { SVGProps } from "react";

const Gxchain = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    viewBox="0 0 446 446"
    {...props}
  >
    <defs>
      <linearGradient
        id="a"
        x1={269.95}
        x2={269.95}
        y1={127.96}
        y2={416}
        gradientTransform="matrix(1 0 0 -1 0 542)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#2f75bb" />
        <stop offset={1} stopColor="#0a4185" />
      </linearGradient>
    </defs>
    <circle cx={223.2} cy={223.2} r={223.2} fill="#b3b3b3" />
    <path
      fill="url(#a)"
      d="M140.7 140.8c18.28-19.12 51.67-19.88 70.57-1.3q29.6 28.93 58.57 58.41c20.57-19.54 39.8-40.38 60.45-59.84 19.65-17.74 53-15.6 70.49 4.28 17.89 18.74 17.6 51.45-1 69.65-19.11 19.46-38.46 38.62-57.73 57.91 19.69 20.3 40.22 39.79 59.74 60.34 17.52 19.21 15.84 51.91-3.13 69.57-18.69 18.86-52.17 18.91-70.82 0-19.4-19-38.38-38.54-57.65-57.66-20.57 19.79-40.18 40.55-61 60.13-19.9 17.66-53.47 15-70.61-5.24-17.26-18.7-16.85-50.57 1.17-68.69 16.92-17.36 34.14-34.43 51.41-51.36 7.23 7.21 14.47 14.47 21.7 21.68-16.93 17.49-34.74 34.22-51.42 52-11.25 11.53-1.34 33 14.46 32.75 9.57.84 16.18-7.09 22.41-13.08 16.51-16.82 33.28-33.34 49.79-50.15-36-36.31-72.58-72.13-108.4-108.61-18.69-18.83-18.1-52.42 1-70.7m20.9 48.82c19.06 19.88 38.84 39 58.23 58.59q14-14.22 28.26-28.26c-18.77-18.91-37.46-38-56.48-56.61-6.06-6.54-16.43-9-24.34-4.28-11 5.33-14.46 21.68-5.69 30.57m186.34-25.79c-35.79 35.14-70.86 71-106.48 106.34 9.62 9.31 19.19 18.66 28.55 28.22 7.19-7.09 14.34-14.26 21.49-21.43 7.23 7.21 14.42 14.47 21.7 21.64-7.06 7.21-14.17 14.34-21.36 21.47 19.31 19.42 38.25 39.21 58.2 58 10.12 10.66 29.77 4.19 32.69-9.85 3.13-9.94-4-18.53-10.74-24.78q-47.6-47.37-95-94.94 10.85-10.82 21.61-21.72c7.19 7.17 14.38 14.34 21.74 21.39 18.94-19.62 39-38.16 57.65-58.08 9.41-9.14 5.64-26.63-6.35-31.58-8.07-4.15-17.9-1.22-23.71 5.32Z"
      transform="translate(-46.58 -43.27)"
    />
  </svg>
);

export default Gxchain;
